// src/components/DashboardLayout.js
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

/**
 * DashboardLayout
 *
 * Proper React Router v6 layout:
 * - Layout renders <Outlet />
 * - Child routes render inside Outlet
 */

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const sidebarDesktopClass = "block w-72 border-r bg-white";

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Mobile overlay sidebar */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 lg:hidden"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="absolute inset-0 bg-black/40"
            onClick={() => setSidebarOpen(false)}
          />
          <div className="relative z-50 w-72 h-full">
            <Sidebar onNavigate={() => setSidebarOpen(false)} />
          </div>
        </div>
      )}

      {/* Desktop sidebar */}
      <div className={sidebarDesktopClass}>
        <Sidebar />
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar onMenuClick={() => setSidebarOpen(true)} />

        <main className="p-6 flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}